import React from 'react';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { LIMITS_STYLES } from '../constants';

interface HeaderProps {
  headerTitle: string;
}

export const Header = ({ headerTitle }: HeaderProps) => (
  <div className={LIMITS_STYLES.LIMITS_HEADER}>
    <Heading.H5 fontWeight={FontWeight.SEMIBOLD}>{headerTitle}</Heading.H5>
  </div>
);
